import VCascaderStore from './index.vue';

export default {
  install: (Vue) => Vue.component('VCascaderStore', VCascaderStore),
};
